import { render, staticRenderFns } from "./FeedBackSummaryTable.vue?vue&type=template&id=06c2a7de&scoped=true&"
import script from "./FeedBackSummaryTable.vue?vue&type=script&lang=js&"
export * from "./FeedBackSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackSummaryTable.vue?vue&type=style&index=0&id=06c2a7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2a7de",
  null
  
)

export default component.exports